import { z } from "zod";
import { validatePhone } from "./india.js";
export const phoneSchema = z
    .string()
    .trim()
    .refine(validatePhone, { message: "Enter a valid 10-digit mobile (starts 6-9) or 0-STD landline" });
export const emailSchema = z.string().trim().toLowerCase().pipe(z.email("Enter a valid email"));
//# sourceMappingURL=schemas.js.map